import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';

const t = block_translation;
export class ARMarkerBlock extends AbstractBlock {
  defineBlock(block: BlockType): void {
    ShapeSettings.setElementWithSubBlockShape(block);
    ColorSettings.setARColor(block);
    ShapeSettings.setTitleField(block, this.title);

    ShapeSettings.setTitleField(block, ' ' + t.to('ロスト時', 'at_lost'));
    const lostMarker = ShapeSettings.getDropDown([
      [t.to('消える', 'disappear'), 'disappear'],
      [t.to('その場に残す', 'stable'), 'stable'],
    ]);
    block.appendDummyInput().appendField(lostMarker, 'lostMarker');
    ShapeSettings.addAttributeInput(block);
    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const lostMarker = CodeSetting.getFieldValue(block, 'lostMarker');

    if (lostMarker === 'stable') {
      /**
       * マーカーロストしても、マーカー位置に物体を配置するモード
       */
      // OUTER BLOCK
      const outerBlock = CodeSetting.getSubstatementCode(block);
      const childBlock = block.getInputTargetBlock('IN');

      // CAMERA
      let cameraAtt = CodeSetting.getAttributeCode('camera', '');
      cameraAtt += CodeSetting.getAttributeCode('look-controls', '');
      const camera = CodeSetting.getElementCode('a-entity', cameraAtt, block.id, '');
      const rigAtt = CodeSetting.getAttributeCode('id', 'rig');
      // rigAtt += CodeSetting.getAttributeCode('movement-controls', '');
      const rig = CodeSetting.getElementCode('a-entity', rigAtt, block.id, camera);

      // INNER BLOCK
      let subAttribute = CodeSetting.getAttributeCode('position', '0 0 0');
      subAttribute += CodeSetting.getAttributeCode('id', '__inner_block');
      subAttribute += CodeSetting.getAttributeCode('wireframe', 'true');
      subAttribute += CodeSetting.getAttributeCode('scale', '1 0 1');
      const innerBlock = CodeSetting.getElementCode('a-box', subAttribute, block.id, '');

      // MARKER
      let attribute = CodeSetting.getSubAttributeCode(block);
      attribute += CodeSetting.getAttributeCode(
        'stable-ar',
        `target:[data-block_id='${childBlock.id}'];key:'${childBlock.id}'`
      );
      attribute += CodeSetting.getAttributeCode('emitevents', `true`);
      attribute += CodeSetting.getAttributeCode('cursor', `rayOrigin: mouse;fuse:false`);
      attribute += CodeSetting.getAttributeCode('raycaster', 'objects: .collidable');
      const markerStr = CodeSetting.getElementCode('a-marker', attribute, block.id, innerBlock);
      return markerStr + rig + outerBlock;
    } else {
      /**
       * マーカーロストしたら、物体は消えるモード（通常のAR)
       */
      let attribute = CodeSetting.getSubAttributeCode(block);
      const sub = CodeSetting.getSubstatementCode(block);
      attribute += CodeSetting.getAttributeCode('emitevents', `true`);
      attribute += CodeSetting.getAttributeCode('cursor', `rayOrigin: mouse;fuse:false`);
      attribute += CodeSetting.getAttributeCode('raycaster', 'objects: .collidable');

      const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, sub);

      // a-marker-camera
      //  -> a-marker  の構成
      const cameraatt = ''; //CodeSetting.getAttributeCode('gps-camera', 'minDistance: 20;');
      // cameraatt += CodeSetting.getAttributeCode('rotation-reader', '');
      const markerCamera = CodeSetting.getElementCode('a-marker-camera', cameraatt, block.id, str);
      return markerCamera;
    }
  }
}
